/** How authors project the board vs audience story visibility. */
export type BoardRevealMode =
  /** Clock / visibility windows as a participant would see; inactive objects omitted. */
  | 'audience'
  /** Authors: ghosts for not-yet-visible; inactive objects hidden (good for demos / Preview). */
  | 'author'
  /** Authors: same clock rules, including inactive objects (full inventory). */
  | 'inventory'

export const BOARD_REVEAL_OPTIONS: { id: BoardRevealMode; label: string }[] = [
  { id: 'author', label: 'Active objects' },
  { id: 'inventory', label: 'All objects' },
  { id: 'audience', label: 'Audience story' },
]
